import { useSelector } from 'react-redux';

import { getIsSidebarOpen, getSidebar } from '../selectors/sidebar';

export const useSidebar = () => useSelector(getSidebar);

export const useIsSidebarOpen = () => useSelector(getIsSidebarOpen);
